import { css, html } from "lit"
import "@luminecence/composants/LibelleChamp"
import PopupBase from "@luminecence/composants/PopupBase"

export default class PopupCommunaute extends PopupBase {
  static properties = {
    id: { type: String },
    nom: { type: String },
    code: { type: String },
    codeUtilisateur: { type: String },
    description: { type: String },
    erreur: { type: String },
    estModeRejoindre: { type: Boolean },
    estModeModification: { type: Boolean },
  }

  static styles = [
    PopupBase.styles,
    css`
    .formulaire .libelle-champ input:disabled {
      opacity: 0.5;
    }
    `,
  ]

  constructor() {
    super()
    this.id = ""
    this.nom = ""
    this.code = ""
    this.description = ""
    this.erreur = ""
    this.estModeRejoindre = false
    this.estModeModification = false
  }

  connectedCallback() {
    super.connectedCallback()
    if (this.id) {
      this.recupererLaCommunaute()
    }
  }

  async recupererLaCommunaute() {
    try {
      const communaute = await window.authentification.bdd.communautes.recupererUneCommunaute(this.id)
      this.nom = communaute.nom
      this.code = communaute.code
      this.description = communaute.description
    } catch (error) {
      console.error("Erreur lors de la récupération de la communauté :", error)
      this.erreur = "Impossible de récupérer les informations de la communauté."
    }
  }

  render() {
    return html`
            <div class="conteneur">
                <h1>${this.estModeRejoindre ? "Rejoindre une communauté" : this.estModeModification ? "Modifier une communauté" : "Créer une communauté"}</h1>
                ${this.erreur ? html`<span class="erreur">${this.erreur}</span>` : ""}
                <div class="formulaire">
                  <p-libelle-champ libelle="nom*" type="text" id-input="nom" .valeur=${this.nom} ?disabled=${this.estModeRejoindre} @evenementChangerValeurChamp=${this.changerNom}></p-libelle-champ>
                  <p-libelle-champ libelle="code" type="text" id-input="code" .valeur=${this.estModeRejoindre ? this.codeUtilisateur || "" : this.code} @evenementChangerValeurChamp=${this.changerCode}></p-libelle-champ>
                  <p-libelle-champ libelle="description" type="text" id-input="description" .valeur=${this.description} ?disabled=${this.estModeRejoindre} @evenementChangerValeurChamp=${this.changerDescription}></p-libelle-champ>
                </div>
            </div>
            ${this.renderBoutons()}
        `
  }

  changerNom(event) {
    this.nom = event.detail?.valeur ?? event.target.value
  }

  changerCode(event) {
    const valeur = event.detail?.valeur ?? event.target.value
    if (this.estModeRejoindre) {
      this.codeUtilisateur = valeur
    } else {
      this.code = valeur
    }
  }

  changerDescription(event) {
    this.description = event.detail?.valeur ?? event.target.value
  }

  valider() {
    // En mode rejoindre, on vérifie que le code entré correspond au code de la communauté
    if (this.estModeRejoindre) {
      if (!this.code) {
        this.admettreUnMembreDansLaCommunaute()
        return
      }
      if (!this.codeUtilisateur) {
        this.erreur = "Veuillez entrer le code de la communauté pour la rejoindre."
        return
      }
      if (this.codeUtilisateur && this.codeUtilisateur !== this.code) {
        this.erreur = "Le code de la communauté est incorrect."
        return
      } else {
        this.erreur = ""
        this.admettreUnMembreDansLaCommunaute()
      }
      // En mode création/modification, on vérifie que le nom est renseigné
    } else {
      this.dispatchEvent(
        new CustomEvent("valider", {
          bubbles: true,
          composed: true,
          detail: { nom: this.nom, code: this.code, description: this.description },
        }),
      )
      this.fermerPopup()
    }
  }

  admettreUnMembreDansLaCommunaute() {
    this.dispatchEvent(
      new CustomEvent("valider", {
        bubbles: true,
        composed: true,
        detail: { admis: true, id: this.id },
      }),
    )
    this.fermerPopup()
  }

  annuler() {
    this.dispatchEvent(
      new CustomEvent("valider", {
        bubbles: true,
        composed: true,
        detail: false,
      }),
    )
    this.fermerPopup()
  }
}

customElements.define("p-popup-communaute", PopupCommunaute)
